const fixedBearings = [ 360, 22.5, 45, 67.5,90, 112.5, 135, 
  157.5,180, 202.5, 225, 247.5,270, 292.5, 315, 337.5 ];

export function getBearingFromCompass(direction: string): number {
  // Mapping compass directions to their bearings
  const compassToBearing: { [key: string]: number } = {
      "N": 360,
      "NNE": 22.5,
      "NE": 45,
      "ENE": 67.5,
      "E": 90,
      "ESE": 112.5,
      "SE": 135,
      "SSE": 157.5,
      "S": 180,
      "SSW": 202.5,
      "SW": 225,
      "WSW": 247.5,
      "W": 270,
      "WNW": 292.5,
      "NW": 315,
      "NNW": 337.5,
  };

  // Convert direction to uppercase and find the bearing
  const bearing = compassToBearing[direction.toUpperCase()];
  if (bearing === undefined) {
      throw new Error(`Invalid compass direction: ${direction}`);
  }
  return bearing;
}

export function getClosestFixedBearing(value: number): number {
    const result = fixedBearings.reduce((closest, current) => {
        return Math.abs(current - value) < Math.abs(closest - value) ? current : closest;
    });
  
    return result;
  }